<router-outlet></router-outlet>

<div class="lauchdarkly-warning" *ngIf="launchDarklyWarning">
  WARNING: You are using Local Feature Flags!
</div>

<app-download-app-banner *ngIf="mobileAppBanner" [prompt]="deferredPrompt">
</app-download-app-banner>
